<div>
    <div class="card-grid-2">
        <a>
            <div class="card-grid-2-image-left">
                <div class="jobsdiv">
                    <div class="image-box"><img src="{{job?.recruiter?.profileImage ? recruiterImagePath+job?.recruiter?.profileImage :'assets/images/brands/ziptech.png'}}" alt="jobBox"></div>
                    <div class="right-info">                      
                        <a class="name-job">{{job?.recruiter?.companyName}} </a>
                        <!-- <span class="location-small">{{job?.recruiter?.location || "-"}}</span> -->
                        <span class="location-small" *ngIf="job?.workPlaceLocation != 'Remote'">{{job?.location || "NA"}}</span>
                      <span class="location-small" *ngIf="job?.workPlaceLocation == 'Remote'">Remote</span>
                    </div>
                </div>
                <div class="mt-3">
                    <span class="card-time">{{dateInMilisecond(job?.createdAt) | dateAgoConvertor}}</span> |
                    <span class="card-applicants">{{job?.applicantsCount}} Applicants</span> |
                    <span class="card-briefcase">{{job?.employement_type?.name || "-"}}</span>
                </div>
            </div>
            <div class="card-block-info">
                <div class="card-block-inner">
                    <h6>{{job?.jobTitle}}
                        <span *ngIf="job?.isApplied == 1"><img src="assets/images/applied.svg" class="wt"></span>
                    </h6>
                    <p class="salary">{{jobSalary(job)}}</p>
                </div>
                <div class="apply">
                    <img src="{{job?.saveStatus == 0 ?  'assets/images/ic_unsave.svg':'assets/images/saved_job.svg'}}"
                        alt="unsave" (click)="saveUnsaveJob();$event.stopPropagation()" tooltip="Save" title="Save" placement="top">
                    <a *ngIf="job?.isApplied == 0" (click)="applyJob();$event.stopPropagation()"
                        class="borderBtn applybtn">Apply now </a>
                    <a *ngIf="job?.isApplied == 1" (click)="withdrawJob();$event.stopPropagation()"
                        class="borderBtn applybtn">Withdraw</a>
                </div>
            </div>
        </a>
    </div>
</div>